import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import BottomNavigation from './BottomNavigation'
import DesktopNavigation from './DesktopNavigation'
import useBreakpoint from '../hooks/useBreakpoint'
import useTelegramBackButton from '../hooks/useTelegramBackButton'

const Layout = () => {
  const location = useLocation()
  const isDesktop = useBreakpoint('(min-width: 1024px)')

  // Интеграция кнопки "Назад" в Telegram
  useTelegramBackButton()

  // Hide navigation on case opening page or upgrader with hideUI param
  const searchParams = new URLSearchParams(location.search)
  const hideNavigation = location.pathname.includes('/opening') ||
                         location.pathname.includes('/battles/create') ||
                         (location.pathname.includes('/upgrader') && searchParams.get('hideUI') === 'true')

  const contentWrapperClassName = isDesktop ? 'w-full max-w-screen-xl mx-auto relative' : 'w-full max-w-[600px] mx-auto relative'
  const mainPaddingClassName = hideNavigation ? '' : isDesktop ? 'pb-8' : 'pb-20'

  return (
    <div className="min-h-screen flex flex-col">
      {!hideNavigation && isDesktop && <DesktopNavigation />}
      
      {/* Wrapper для ограничения ширины только на мобильных экранах */}
      <div className={contentWrapperClassName}>
        {/* Main Content */}
        <main className={`flex-1 ${mainPaddingClassName}`}>
          <Outlet />
        </main>

        {/* Нижняя навигация показывается только на мобильных экранах */}
        {!hideNavigation && !isDesktop && <BottomNavigation />}
      </div>
    </div>
  )
}

export default Layout
